import React from 'react';

const defaultCustomerContextValue = {
  membershipInformation: null,
  THDCustomer: null,
  isExchangeCustomer: false,
  exchangeCustomerCookies: null
};

export const CustomerContext = React.createContext(defaultCustomerContextValue);